import React__default, { forwardRef, useState, useRef } from 'react';
import _s, { css } from 'styled-components';
import { a as getDefaultExportFromCjs } from './_commonjsHelpers-357b3b4e.js';
import ReactDOM__default from 'react-dom';
import { r as requirePropTypes } from './index-48edd52c.js';
import { r as requireWarning } from './warning-16243c28.js';
import { n as noop } from './noop-fc861ff1.js';
import Box from './Box.js';
import Icon from './Icon.js';
import Typography from './Typography.js';

function mergeRefs(refs) {
  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}

var reactInputMask = {exports: {}};

var reactInputMask_production_min = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant_1;
var hasRequiredInvariant;

function requireInvariant () {
	if (hasRequiredInvariant) return invariant_1;
	hasRequiredInvariant = 1;

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var NODE_ENV = process.env.NODE_ENV;

	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};

	invariant_1 = invariant;
	return invariant_1;
}

var hasRequiredReactInputMask_production_min;

function requireReactInputMask_production_min () {
	if (hasRequiredReactInputMask_production_min) return reactInputMask_production_min.exports;
	hasRequiredReactInputMask_production_min = 1;
function t(t){return t&&"object"==typeof t&&"default"in t?t.default:t}var e=React__default,n=t(e),i=ReactDOM__default;requirePropTypes();var r=t(requireInvariant());function a(){return (a=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i]);}return t}).apply(this,arguments)}function o(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,function(t,e){for(var n=Object.getOwnPropertyNames(e),i=0;i<n.length;i++){var r=n[i],a=Object.getOwnPropertyDescriptor(e,r);a&&a.configurable&&void 0===t[r]&&Object.defineProperty(t,r,a);}}(t,e);}function l(t,e){if(null==t)return {};var n,i,r={},a=Object.keys(t);for(i=0;i<a.length;i++)n=a[i],e.indexOf(n)>=0||(r[n]=t[n]);return r}function u(t){return requestAnimationFrame(t)}function s(t){cancelAnimationFrame(t);}function c(t){var e=t.ownerDocument;return e.hasFocus()&&e.activeElement===t}function f(t){return null==t?void 0:t.ownerDocument}function h(t){var e=function(t){var e;return null==(e=f(t))?void 0:e.defaultView}(t);return !!e&&t instanceof e.HTMLElement}function g(t){return e.useCallback((function(){var e=t.current,n="undefined"!=typeof window&&h(e);if(!e||!n)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e}),[t])}function v(t,n){var i,r,a,o,l=e.useRef({start:null,end:null}),f=g(t),h=e.useCallback((function(){return function(t){var e=t.selectionStart,n=t.selectionEnd;return {start:e,end:n,length:n-e}}(f())}),[f]),v=e.useCallback((function(){return l.current}),[]),d=e.useCallback((function(t){var e=f();e&&c(e)&&(!function(t,e,n){void 0===n&&(n=e),t.setSelectionRange(e,n);}(e,t.start,t.end),l.current=h());}),[f,h]),p=e.useCallback((function(){l.current=h();}),[h]),m=(i=p,r=e.useRef(null),a=e.useCallback((function(){null===r.current&&function t(){i(),r.current=u(t);}();}),[i]),o=e.useCallback((function(){s(r.current),r.current=null;}),[]),e.useEffect((function(){r.current&&(o(),a());}),[a,o]),e.useEffect(s,[]),[a,o]),P=m[0],k=m[1];return e.useLayoutEffect((function(){if(n){var t=f();return t.addEventListener("focus",P),t.addEventListener("blur",k),c(t)&&P(),function(){t.removeEventListener("focus",P),t.removeEventListener("blur",k),k();}}})),{getSelection:h,getLastSelection:v,setSelection:d}}function d(t,n){var i=e.useRef(),r=v(i,n),a=r.getSelection,o=r.getLastSelection,l=r.setSelection,u=function(t,n){var i=g(t),r=e.useRef(n);return {getValue:e.useCallback((function(){return i().value}),[i]),getLastValue:e.useCallback((function(){return r.current}),[]),setValue:e.useCallback((function(t){r.current=t;var e=i();e&&(e.value=t);}),[i])}}(i,t),s=u.getValue,c=u.getLastValue,f=u.setValue;return {inputRef:i,getInputState:function(){return {value:s(),selection:a()}},getLastInputState:function(){return {value:c(),selection:o()}},setInputState:function(t){var e=t.value,n=t.selection;f(e),l(n);}}}requireWarning();var p=["disabled","onBlur","onChange","onFocus","onMouseDown","readOnly","value"],m={9:/[0-9]/,a:/[A-Za-z]/,"*":/[A-Za-z0-9]/};var P=function(t){var e=this;this.isCharacterAllowedAtPosition=function(t,n){var i=e.maskOptions.maskPlaceholder;return !!e.isCharacterFillingPosition(t,n)||!!i&&i[n]===t},this.isCharacterFillingPosition=function(t,n){var i=e.maskOptions.mask;if(!t||n>=i.length)return !1;if(!e.isPositionEditable(n))return i[n]===t;var r=i[n];return new RegExp(r).test(t)},this.isPositionEditable=function(t){var n=e.maskOptions,i=n.mask,r=n.permanents;return t<i.length&&-1===r.indexOf(t)},this.isValueEmpty=function(t){return t.split("").every((function(t,n){return !e.isPositionEditable(n)||!e.isCharacterFillingPosition(t,n)}))},this.isValueFilled=function(t){return e.getFilledLength(t)===e.maskOptions.lastEditablePosition+1},this.getDefaultSelectionForValue=function(t){var n=e.getFilledLength(t),i=e.getRightEditablePosition(n);return {start:i,end:i}},this.getFilledLength=function(t){return function(t,e){for(var n=t.length-1;n>=0;n--){if(e(t[n],n))return n}return -1}(t.split(""),(function(t,n){return e.isPositionEditable(n)&&e.isCharacterFillingPosition(t,n)}))+1},this.getStringFillingLengthAtPosition=function(t,n){return t.split("").reduce((function(t,n){return e.insertCharacterAtPosition(t,n,t.length)}),function(t,e){void 0===e&&(e=1);for(var n="",i=0;i<e;i++)n+=t;return n}(" ",n)).length-n},this.getLeftEditablePosition=function(t){for(var n=t;n>=0;n--)if(e.isPositionEditable(n))return n;return null},this.getRightEditablePosition=function(t){for(var n=e.maskOptions.mask,i=t;i<n.length;i++)if(e.isPositionEditable(i))return i;return null},this.formatValue=function(t){var n=e.maskOptions,i=n.maskPlaceholder,r=n.mask;if(!i){for(t=e.insertStringAtPosition("",t,0);t.length<r.length&&!e.isPositionEditable(t.length);)t+=r[t.length];return t}return e.insertStringAtPosition(i,t,0)},this.clearRange=function(t,n,i){if(!i)return t;var r=n+i,a=e.maskOptions,o=a.maskPlaceholder,l=a.mask,u=t.split("").map((function(t,i){var a=e.isPositionEditable(i);return !o&&i>=r&&!a?"":i<n||i>=r?t:a?o?o[i]:"":l[i]})).join("");return e.formatValue(u)},this.insertCharacterAtPosition=function(t,n,i){var r=e.maskOptions,a=r.mask,o=r.maskPlaceholder;if(i>=a.length)return t;var l=e.isCharacterAllowedAtPosition(n,i),u=e.isPositionEditable(i),s=e.getRightEditablePosition(i),c=o&&s?n===o[s]:null,f=t.slice(0,i);!l&&u||(t=f+(l?n:a[i]));return l||u||c||(t=e.insertCharacterAtPosition(t,n,i+1)),t},this.insertStringAtPosition=function(t,n,i){var r=e.maskOptions,a=r.mask,o=r.maskPlaceholder;if(!n||i>=a.length)return t;var l=n.split(""),u=e.isValueFilled(t)||!!o,s=t.slice(i);if(t=l.reduce((function(t,n){return e.insertCharacterAtPosition(t,n,t.length)}),t.slice(0,i)),u)t+=s.slice(t.length-i);else if(e.isValueFilled(t))t+=a.slice(t.length).join("");else {t=s.split("").filter((function(t,n){return e.isPositionEditable(i+n)})).reduce((function(t,n){var i=e.getRightEditablePosition(t.length);return null===i?t:(e.isPositionEditable(t.length)||(t+=a.slice(t.length,i).join("")),e.insertCharacterAtPosition(t,n,t.length))}),t);}return t},this.processChange=function(t,n){var i=e.maskOptions,r=i.mask,a=i.prefix,o=i.lastEditablePosition,l=t.value,u=t.selection,s=n.value,c=n.selection,f=l,h="",g=0,v=0,d=Math.min(c.start,u.start);if(u.end>c.start?(h=f.slice(c.start,u.end),v=(g=e.getStringFillingLengthAtPosition(h,d))?c.length:0):f.length<s.length&&(v=s.length-f.length),f=s,v){if(1===v&&!c.length)d=c.start===u.start?e.getRightEditablePosition(u.start):e.getLeftEditablePosition(u.start);f=e.clearRange(f,d,v);}return f=e.insertStringAtPosition(f,h,d),(d+=g)>=r.length?d=r.length:d<a.length&&!g?d=a.length:d>=a.length&&d<o&&g&&(d=e.getRightEditablePosition(d)),{value:f=e.formatValue(f),enteredString:h,selection:{start:d,end:d}}},this.maskOptions=function(t){var e=t.mask,n=t.maskPlaceholder,i=[];if(!e)return {maskPlaceholder:null,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};if("string"==typeof e){var r=!1,a="";e.split("").forEach((function(t){r||"\\"!==t?(!r&&m[t]||i.push(a.length),a+=t,r=!1):r=!0;})),e=a.split("").map((function(t,e){return -1===i.indexOf(e)?m[t]:t}));}else e.forEach((function(t,e){"string"==typeof t&&i.push(e);}));n&&(n=1===n.length?e.map((function(t,e){return -1!==i.indexOf(e)?t:n})):n.split(""),i.forEach((function(t){n[t]=e[t];})),n=n.join(""));for(var o=i.filter((function(t,e){return t===e})).map((function(t){return e[t]})).join(""),l=e.length-1;-1!==i.indexOf(l);)l--;return {maskPlaceholder:n,prefix:o,mask:e,lastEditablePosition:l,permanents:i}}(t);},k=function(t){function e(){return t.apply(this,arguments)||this}return o(e,t),e.prototype.render=function(){var t=this.props,e=t.children,i=l(t,["children"]);return n.cloneElement(e,i)},e}(n.Component),b=e.forwardRef((function(t,o){var s=t.alwaysShowMask,h=t.children,v=t.mask,m=t.maskPlaceholder,b=t.beforeMaskedStateChange,E=l(t,["alwaysShowMask","children","mask","maskPlaceholder","beforeMaskedStateChange"]);!function(t){var e=t.mask,n=t.maskPlaceholder;e&&n&&1!==n.length&&n.length!==e.length&&r(!1);}(t);var S,C,y=new P({mask:v,maskPlaceholder:m}),w=!!v,O=!E.disabled&&!E.readOnly,V=null!==t.value&&void 0!==t.value,F=(S=w,C=e.useRef(),e.useEffect((function(){C.current=S;})),C.current),L=d(function(t){return ""+t}((V?t.value:t.defaultValue)||""),w),A=L.inputRef,R=L.getInputState,M=L.setInputState,x=L.getLastInputState,D=g(A);if(w&&V){var j=D(),I=j&&c(j)||s||t.value?y.formatValue(t.value):t.value;b&&(I=b({nextState:{value:I,selection:{start:null,end:null}}}).value),M(a({},x(),{value:I}));}var q=x(),N=q.selection,B=q.value;e.useLayoutEffect((function(){if(w){var t=c(D()),e=N,n=R(),i=a({},n);if(!V){var r=n.value,o=y.formatValue(r),l=y.isValueEmpty(o);!l||t||s?i.value=o:l&&!t&&(i.value="");}t&&!F?i.selection=y.getDefaultSelectionForValue(i.value):V&&t&&e&&null!==e.start&&null!==e.end&&(i.selection=e),b&&(i=b({currentState:n,nextState:i})),M(i);}}));var T=a({},E,{onFocus:function(e){A.current=e.target;var n=R().value;if(w&&!y.isValueFilled(n)){var i=y.formatValue(n),r=y.getDefaultSelectionForValue(i),a={value:i,selection:r};b&&(i=(a=b({currentState:R(),nextState:a})).value,r=a.selection),M(a),i!==n&&t.onChange&&t.onChange(e),u((function(){M(x());}));}t.onFocus&&t.onFocus(e);},onBlur:function(e){var n=R().value,i=x().value;if(w&&!s&&y.isValueEmpty(i)){var r="",a={value:r,selection:{start:null,end:null}};b&&(r=(a=b({currentState:R(),nextState:a})).value),M(a),r!==n&&t.onChange&&t.onChange(e);}t.onBlur&&t.onBlur(e);},onChange:w&&O?function(e){var n=R(),i=x(),r=y.processChange(n,i);b&&(r=b({currentState:n,previousState:i,nextState:r})),M(r),t.onChange&&t.onChange(e);}:t.onChange,onMouseDown:w&&O?function(e){var n=D(),i=R().value,r=f(n);if(!c(n)&&!y.isValueFilled(i)){var o=e.clientX,l=e.clientY,u=(new Date).getTime();r.addEventListener("mouseup",(function t(e){if(r.removeEventListener("mouseup",t),c(n)){var i=Math.abs(e.clientX-o),s=Math.abs(e.clientY-l),f=Math.max(i,s),h=(new Date).getTime()-u;if(f<=10&&h<=200||f<=5&&h<=300){var g=x(),v=a({},g,{selection:y.getDefaultSelectionForValue(g.value)});M(v);}}}));}t.onMouseDown&&t.onMouseDown(e);}:t.onMouseDown,ref:function(t){A.current=i.findDOMNode(t),!function(t){return "function"==typeof t}(o)?null!==o&&"object"==typeof o&&(o.current=t):o(t);},value:w&&V?B:t.value});return h?(function(t,e){p.filter((function(n){return null!=e.props[n]&&e.props[n]!==t[n]})).length&&r(!1);}(t,h),n.createElement(k,T,h)):n.createElement("input",T)}));b.displayName="InputMask",b.defaultProps={alwaysShowMask:!1,maskPlaceholder:"_"},reactInputMask_production_min.exports=b;
	return reactInputMask_production_min.exports;
}

var reactInputMask_development;
var hasRequiredReactInputMask_development;

function requireReactInputMask_development () {
	if (hasRequiredReactInputMask_development) return reactInputMask_development;
	hasRequiredReactInputMask_development = 1;

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

	var React = React__default;
	var React__default$1 = _interopDefault(React);
	var reactDom = ReactDOM__default;
	var PropTypes = _interopDefault(requirePropTypes());
	var invariant = _interopDefault(requireInvariant());
	var warning = _interopDefault(requireWarning());

	function _defaults2(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends.apply(this, arguments);
	}

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;

	  _defaults2(subClass, superClass);
	}

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	function defer(fn) {
	  return requestAnimationFrame(fn);
	}
	function cancelDefer(deferId) {
	  cancelAnimationFrame(deferId);
	}

	function setInputSelection(input, start, end) {
	  if (end === undefined) {
	    end = start;
	  }

	  input.setSelectionRange(start, end);
	}
	function getInputSelection(input) {
	  var start = input.selectionStart;
	  var end = input.selectionEnd;
	  return {
	    start: start,
	    end: end,
	    length: end - start
	  };
	}
	function isInputFocused(input) {
	  var inputDocument = input.ownerDocument;
	  return inputDocument.hasFocus() && inputDocument.activeElement === input;
	}

	// Element's window may differ from the one within React instance
	// if element rendered within iframe.
	// See https://github.com/sanniassin/react-input-mask/issues/182
	function getElementDocument(element) {
	  return element == null ? void 0 : element.ownerDocument;
	}
	function getElementWindow(element) {
	  var _getElementDocument;

	  return (_getElementDocument = getElementDocument(element)) == null ? void 0 : _getElementDocument.defaultView;
	}
	function isDOMElement(element) {
	  var elementWindow = getElementWindow(element);
	  return !!elementWindow && element instanceof elementWindow.HTMLElement;
	}
	function isFunction(value) {
	  return typeof value === "function";
	}
	function findLastIndex(array, predicate) {
	  for (var i = array.length - 1; i >= 0; i--) {
	    var x = array[i];

	    if (predicate(x, i)) {
	      return i;
	    }
	  }

	  return -1;
	}
	function repeat(string, n) {
	  if (n === void 0) {
	    n = 1;
	  }

	  var result = "";

	  for (var i = 0; i < n; i++) {
	    result += string;
	  }

	  return result;
	}
	function toString(value) {
	  return "" + value;
	}

	function useInputElement(inputRef) {
	  return React.useCallback(function () {
	    var input = inputRef.current;
	    var isDOMNode = typeof window !== "undefined" && isDOMElement(input); // workaround for react-test-renderer
	    // https://github.com/sanniassin/react-input-mask/issues/147

	    if (!input || !isDOMNode) {
	      return null;
	    }

	    if (input.nodeName !== "INPUT") {
	      input = input.querySelector("input");
	    }

	    if (!input) {
	      throw new Error("react-input-mask: inputComponent doesn't contain input node");
	    }

	    return input;
	  }, [inputRef]);
	}

	function useDeferLoop(callback) {
	  var deferIdRef = React.useRef(null);
	  var runLoop = React.useCallback(function () {
	    // If there are simulated focus events, runLoop could be
	    // called multiple times without blur or re-render
	    if (deferIdRef.current !== null) {
	      return;
	    }

	    function loop() {
	      callback();
	      deferIdRef.current = defer(loop);
	    }

	    loop();
	  }, [callback]);
	  var stopLoop = React.useCallback(function () {
	    cancelDefer(deferIdRef.current);
	    deferIdRef.current = null;
	  }, []);
	  React.useEffect(function () {
	    if (deferIdRef.current) {
	      stopLoop();
	      runLoop();
	    }
	  }, [runLoop, stopLoop]);
	  React.useEffect(cancelDefer, []);
	  return [runLoop, stopLoop];
	}

	function useSelection(inputRef, isMasked) {
	  var selectionRef = React.useRef({
	    start: null,
	    end: null
	  });
	  var getInputElement = useInputElement(inputRef);
	  var getSelection = React.useCallback(function () {
	    var input = getInputElement();
	    return getInputSelection(input);
	  }, [getInputElement]);
	  var getLastSelection = React.useCallback(function () {
	    return selectionRef.current;
	  }, []);
	  var setSelection = React.useCallback(function (selection) {
	    var input = getInputElement(); // Don't change selection on unfocused input
	    // because Safari sets focus on selection change (#154)

	    if (!input || !isInputFocused(input)) {
	      return;
	    }

	    setInputSelection(input, selection.start, selection.end); // Use actual selection in case the requested one was out of range

	    selectionRef.current = getSelection();
	  }, [getInputElement, getSelection]);
	  var selectionLoop = React.useCallback(function () {
	    selectionRef.current = getSelection();
	  }, [getSelection]);

	  var _useDeferLoop = useDeferLoop(selectionLoop),
	      runSelectionLoop = _useDeferLoop[0],
	      stopSelectionLoop = _useDeferLoop[1];

	  React.useLayoutEffect(function () {
	    if (!isMasked) {
	      return;
	    }

	    var input = getInputElement();
	    input.addEventListener("focus", runSelectionLoop);
	    input.addEventListener("blur", stopSelectionLoop);

	    if (isInputFocused(input)) {
	      runSelectionLoop();
	    }

	    return function () {
	      input.removeEventListener("focus", runSelectionLoop);
	      input.removeEventListener("blur", stopSelectionLoop);
	      stopSelectionLoop();
	    };
	  });
	  return {
	    getSelection: getSelection,
	    getLastSelection: getLastSelection,
	    setSelection: setSelection
	  };
	}

	function useValue(inputRef, initialValue) {
	  var getInputElement = useInputElement(inputRef);
	  var valueRef = React.useRef(initialValue);
	  var getValue = React.useCallback(function () {
	    var input = getInputElement();
	    return input.value;
	  }, [getInputElement]);
	  var getLastValue = React.useCallback(function () {
	    return valueRef.current;
	  }, []);
	  var setValue = React.useCallback(function (newValue) {
	    valueRef.current = newValue;
	    var input = getInputElement();

	    if (input) {
	      input.value = newValue;
	    }
	  }, [getInputElement]);
	  return {
	    getValue: getValue,
	    getLastValue: getLastValue,
	    setValue: setValue
	  };
	}

	function useInputState(initialValue, isMasked) {
	  var inputRef = React.useRef();

	  var _useSelection = useSelection(inputRef, isMasked),
	      getSelection = _useSelection.getSelection,
	      getLastSelection = _useSelection.getLastSelection,
	      setSelection = _useSelection.setSelection;

	  var _useValue = useValue(inputRef, initialValue),
	      getValue = _useValue.getValue,
	      getLastValue = _useValue.getLastValue,
	      setValue = _useValue.setValue;

	  function getLastInputState() {
	    return {
	      value: getLastValue(),
	      selection: getLastSelection()
	    };
	  }

	  function getInputState() {
	    return {
	      value: getValue(),
	      selection: getSelection()
	    };
	  }

	  function setInputState(_ref) {
	    var value = _ref.value,
	        selection = _ref.selection;
	    setValue(value);
	    setSelection(selection);
	  }

	  return {
	    inputRef: inputRef,
	    getInputState: getInputState,
	    getLastInputState: getLastInputState,
	    setInputState: setInputState
	  };
	}
	function usePrevious(value) {
	  var ref = React.useRef();
	  React.useEffect(function () {
	    ref.current = value;
	  });
	  return ref.current;
	}

	var CONTROLLED_PROPS = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"];
	var defaultFormatChars = {
	  "9": /[0-9]/,
	  a: /[A-Za-z]/,
	  "*": /[A-Za-z0-9]/
	};

	function validateMaxLength(props) {
	  process.env.NODE_ENV !== "production" ? warning(!props.maxLength || !props.mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.") : void 0;
	}
	function validateMaskPlaceholder(props) {
	  var mask = props.mask,
	      maskPlaceholder = props.maskPlaceholder;
	  !(!mask || !maskPlaceholder || maskPlaceholder.length === 1 || maskPlaceholder.length === mask.length) ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: maskPlaceholder should either be a single character or have the same length as the mask:\n" + ("mask: " + mask + "\n") + ("maskPlaceholder: " + maskPlaceholder)) : invariant(false) : void 0;
	}
	function validateChildren(props, inputElement) {
	  var conflictProps = CONTROLLED_PROPS.filter(function (propId) {
	    return inputElement.props[propId] != null && inputElement.props[propId] !== props[propId];
	  });
	  !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: the following props should be passed to the InputMask component, not to children: " + conflictProps.join(",")) : invariant(false) : void 0;
	}

	function parseMask (_ref) {
	  var mask = _ref.mask,
	      maskPlaceholder = _ref.maskPlaceholder;
	  var permanents = [];

	  if (!mask) {
	    return {
	      maskPlaceholder: null,
	      mask: null,
	      prefix: null,
	      lastEditablePosition: null,
	      permanents: []
	    };
	  }

	  if (typeof mask === "string") {
	    var isPermanent = false;
	    var parsedMaskString = "";
	    mask.split("").forEach(function (character) {
	      if (!isPermanent && character === "\\") {
	        isPermanent = true;
	      } else {
	        if (isPermanent || !defaultFormatChars[character]) {
	          permanents.push(parsedMaskString.length);
	        }

	        parsedMaskString += character;
	        isPermanent = false;
	      }
	    });
	    mask = parsedMaskString.split("").map(function (character, index) {
	      if (permanents.indexOf(index) === -1) {
	        return defaultFormatChars[character];
	      }

	      return character;
	    });
	  } else {
	    mask.forEach(function (character, index) {
	      if (typeof character === "string") {
	        permanents.push(index);
	      }
	    });
	  }

	  if (maskPlaceholder) {
	    if (maskPlaceholder.length === 1) {
	      maskPlaceholder = mask.map(function (character, index) {
	        if (permanents.indexOf(index) !== -1) {
	          return character;
	        }

	        return maskPlaceholder;
	      });
	    } else {
	      maskPlaceholder = maskPlaceholder.split("");
	    }

	    permanents.forEach(function (position) {
	      maskPlaceholder[position] = mask[position];
	    });
	    maskPlaceholder = maskPlaceholder.join("");
	  }

	  var prefix = permanents.filter(function (position, index) {
	    return position === index;
	  }).map(function (position) {
	    return mask[position];
	  }).join("");
	  var lastEditablePosition = mask.length - 1;

	  while (permanents.indexOf(lastEditablePosition) !== -1) {
	    lastEditablePosition--;
	  }

	  return {
	    maskPlaceholder: maskPlaceholder,
	    prefix: prefix,
	    mask: mask,
	    lastEditablePosition: lastEditablePosition,
	    permanents: permanents
	  };
	}

	/* eslint no-use-before-define: ["error", { functions: false }] */

	var MaskUtils = function MaskUtils(options) {
	  var _this = this;

	  this.isCharacterAllowedAtPosition = function (character, position) {
	    var maskPlaceholder = _this.maskOptions.maskPlaceholder;

	    if (_this.isCharacterFillingPosition(character, position)) {
	      return true;
	    }

	    if (!maskPlaceholder) {
	      return false;
	    }

	    return maskPlaceholder[position] === character;
	  };

	  this.isCharacterFillingPosition = function (character, position) {
	    var mask = _this.maskOptions.mask;

	    if (!character || position >= mask.length) {
	      return false;
	    }

	    if (!_this.isPositionEditable(position)) {
	      return mask[position] === character;
	    }

	    var charRule = mask[position];
	    return new RegExp(charRule).test(character);
	  };

	  this.isPositionEditable = function (position) {
	    var _this$maskOptions = _this.maskOptions,
	        mask = _this$maskOptions.mask,
	        permanents = _this$maskOptions.permanents;
	    return position < mask.length && permanents.indexOf(position) === -1;
	  };

	  this.isValueEmpty = function (value) {
	    return value.split("").every(function (character, position) {
	      return !_this.isPositionEditable(position) || !_this.isCharacterFillingPosition(character, position);
	    });
	  };

	  this.isValueFilled = function (value) {
	    return _this.getFilledLength(value) === _this.maskOptions.lastEditablePosition + 1;
	  };

	  this.getDefaultSelectionForValue = function (value) {
	    var filledLength = _this.getFilledLength(value);

	    var cursorPosition = _this.getRightEditablePosition(filledLength);

	    return {
	      start: cursorPosition,
	      end: cursorPosition
	    };
	  };

	  this.getFilledLength = function (value) {
	    var characters = value.split("");
	    var lastFilledIndex = findLastIndex(characters, function (character, position) {
	      return _this.isPositionEditable(position) && _this.isCharacterFillingPosition(character, position);
	    });
	    return lastFilledIndex + 1;
	  };

	  this.getStringFillingLengthAtPosition = function (string, position) {
	    var characters = string.split("");
	    var insertedValue = characters.reduce(function (value, character) {
	      return _this.insertCharacterAtPosition(value, character, value.length);
	    }, repeat(" ", position));
	    return insertedValue.length - position;
	  };

	  this.getLeftEditablePosition = function (position) {
	    for (var i = position; i >= 0; i--) {
	      if (_this.isPositionEditable(i)) {
	        return i;
	      }
	    }

	    return null;
	  };

	  this.getRightEditablePosition = function (position) {
	    var mask = _this.maskOptions.mask;

	    for (var i = position; i < mask.length; i++) {
	      if (_this.isPositionEditable(i)) {
	        return i;
	      }
	    }

	    return null;
	  };

	  this.formatValue = function (value) {
	    var _this$maskOptions2 = _this.maskOptions,
	        maskPlaceholder = _this$maskOptions2.maskPlaceholder,
	        mask = _this$maskOptions2.mask;

	    if (!maskPlaceholder) {
	      value = _this.insertStringAtPosition("", value, 0);

	      while (value.length < mask.length && !_this.isPositionEditable(value.length)) {
	        value += mask[value.length];
	      }

	      return value;
	    }

	    return _this.insertStringAtPosition(maskPlaceholder, value, 0);
	  };

	  this.clearRange = function (value, start, len) {
	    if (!len) {
	      return value;
	    }

	    var end = start + len;
	    var _this$maskOptions3 = _this.maskOptions,
	        maskPlaceholder = _this$maskOptions3.maskPlaceholder,
	        mask = _this$maskOptions3.mask;
	    var clearedValue = value.split("").map(function (character, i) {
	      var isEditable = _this.isPositionEditable(i);

	      if (!maskPlaceholder && i >= end && !isEditable) {
	        return "";
	      }

	      if (i < start || i >= end) {
	        return character;
	      }

	      if (!isEditable) {
	        return mask[i];
	      }

	      if (maskPlaceholder) {
	        return maskPlaceholder[i];
	      }

	      return "";
	    }).join("");
	    return _this.formatValue(clearedValue);
	  };

	  this.insertCharacterAtPosition = function (value, character, position) {
	    var _this$maskOptions4 = _this.maskOptions,
	        mask = _this$maskOptions4.mask,
	        maskPlaceholder = _this$maskOptions4.maskPlaceholder;

	    if (position >= mask.length) {
	      return value;
	    }

	    var isAllowed = _this.isCharacterAllowedAtPosition(character, position);

	    var isEditable = _this.isPositionEditable(position);

	    var nextEditablePosition = _this.getRightEditablePosition(position);

	    var isNextPlaceholder = maskPlaceholder && nextEditablePosition ? character === maskPlaceholder[nextEditablePosition] : null;
	    var valueBefore = value.slice(0, position);

	    if (isAllowed || !isEditable) {
	      var insertedCharacter = isAllowed ? character : mask[position];
	      value = valueBefore + insertedCharacter;
	    }

	    if (!isAllowed && !isEditable && !isNextPlaceholder) {
	      value = _this.insertCharacterAtPosition(value, character, position + 1);
	    }

	    return value;
	  };

	  this.insertStringAtPosition = function (value, string, position) {
	    var _this$maskOptions5 = _this.maskOptions,
	        mask = _this$maskOptions5.mask,
	        maskPlaceholder = _this$maskOptions5.maskPlaceholder;

	    if (!string || position >= mask.length) {
	      return value;
	    }

	    var characters = string.split("");
	    var isFixedLength = _this.isValueFilled(value) || !!maskPlaceholder;
	    var valueAfter = value.slice(position);
	    value = characters.reduce(function (value, character) {
	      return _this.insertCharacterAtPosition(value, character, value.length);
	    }, value.slice(0, position));

	    if (isFixedLength) {
	      value += valueAfter.slice(value.length - position);
	    } else if (_this.isValueFilled(value)) {
	      value += mask.slice(value.length).join("");
	    } else {
	      var editableCharactersAfter = valueAfter.split("").filter(function (character, i) {
	        return _this.isPositionEditable(position + i);
	      });
	      value = editableCharactersAfter.reduce(function (value, character) {
	        var nextEditablePosition = _this.getRightEditablePosition(value.length);

	        if (nextEditablePosition === null) {
	          return value;
	        }

	        if (!_this.isPositionEditable(value.length)) {
	          value += mask.slice(value.length, nextEditablePosition).join("");
	        }

	        return _this.insertCharacterAtPosition(value, character, value.length);
	      }, value);
	    }

	    return value;
	  };

	  this.processChange = function (currentState, previousState) {
	    var _this$maskOptions6 = _this.maskOptions,
	        mask = _this$maskOptions6.mask,
	        prefix = _this$maskOptions6.prefix,
	        lastEditablePosition = _this$maskOptions6.lastEditablePosition;
	    var value = currentState.value,
	        selection = currentState.selection;
	    var previousValue = previousState.value;
	    var previousSelection = previousState.selection;
	    var newValue = value;
	    var enteredString = "";
	    var formattedEnteredStringLength = 0;
	    var removedLength = 0;
	    var cursorPosition = Math.min(previousSelection.start, selection.start);

	    if (selection.end > previousSelection.start) {
	      enteredString = newValue.slice(previousSelection.start, selection.end);
	      formattedEnteredStringLength = _this.getStringFillingLengthAtPosition(enteredString, cursorPosition);

	      if (!formattedEnteredStringLength) {
	        removedLength = 0;
	      } else {
	        removedLength = previousSelection.length;
	      }
	    } else if (newValue.length < previousValue.length) {
	      removedLength = previousValue.length - newValue.length;
	    }

	    newValue = previousValue;

	    if (removedLength) {
	      if (removedLength === 1 && !previousSelection.length) {
	        var deleteFromRight = previousSelection.start === selection.start;
	        cursorPosition = deleteFromRight ? _this.getRightEditablePosition(selection.start) : _this.getLeftEditablePosition(selection.start);
	      }

	      newValue = _this.clearRange(newValue, cursorPosition, removedLength);
	    }

	    newValue = _this.insertStringAtPosition(newValue, enteredString, cursorPosition);
	    cursorPosition += formattedEnteredStringLength;

	    if (cursorPosition >= mask.length) {
	      cursorPosition = mask.length;
	    } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
	      cursorPosition = prefix.length;
	    } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
	      cursorPosition = _this.getRightEditablePosition(cursorPosition);
	    }

	    newValue = _this.formatValue(newValue);
	    return {
	      value: newValue,
	      enteredString: enteredString,
	      selection: {
	        start: cursorPosition,
	        end: cursorPosition
	      }
	    };
	  };

	  this.maskOptions = parseMask(options);
	};

	var InputMaskChildrenWrapper =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InputMaskChildrenWrapper, _React$Component);

	  function InputMaskChildrenWrapper() {
	    return _React$Component.apply(this, arguments) || this;
	  }

	  var _proto = InputMaskChildrenWrapper.prototype;

	  _proto.render = function render() {
	    // eslint-disable-next-line react/prop-types
	    var _this$props = this.props,
	        children = _this$props.children,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

	    return React__default$1.cloneElement(children, props);
	  };

	  return InputMaskChildrenWrapper;
	}(React__default$1.Component);

	var InputMask = React.forwardRef(function InputMask(props, forwardedRef) {
	  var alwaysShowMask = props.alwaysShowMask,
	      children = props.children,
	      mask = props.mask,
	      maskPlaceholder = props.maskPlaceholder,
	      beforeMaskedStateChange = props.beforeMaskedStateChange,
	      restProps = _objectWithoutPropertiesLoose(props, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);

	  validateMaxLength(props);
	  validateMaskPlaceholder(props);
	  var maskUtils = new MaskUtils({
	    mask: mask,
	    maskPlaceholder: maskPlaceholder
	  });
	  var isMasked = !!mask;
	  var isEditable = !restProps.disabled && !restProps.readOnly;
	  var isControlled = props.value !== null && props.value !== undefined;
	  var previousIsMasked = usePrevious(isMasked);
	  var initialValue = toString((isControlled ? props.value : props.defaultValue) || "");

	  var _useInputState = useInputState(initialValue, isMasked),
	      inputRef = _useInputState.inputRef,
	      getInputState = _useInputState.getInputState,
	      setInputState = _useInputState.setInputState,
	      getLastInputState = _useInputState.getLastInputState;

	  var getInputElement = useInputElement(inputRef);

	  function onChange(event) {
	    var currentState = getInputState();
	    var previousState = getLastInputState();
	    var newInputState = maskUtils.processChange(currentState, previousState);

	    if (beforeMaskedStateChange) {
	      newInputState = beforeMaskedStateChange({
	        currentState: currentState,
	        previousState: previousState,
	        nextState: newInputState
	      });
	    }

	    setInputState(newInputState);

	    if (props.onChange) {
	      props.onChange(event);
	    }
	  }

	  function onFocus(event) {
	    // If autoFocus property is set, focus event fires before the ref handler gets called
	    inputRef.current = event.target;
	    var currentValue = getInputState().value;

	    if (isMasked && !maskUtils.isValueFilled(currentValue)) {
	      var newValue = maskUtils.formatValue(currentValue);
	      var newSelection = maskUtils.getDefaultSelectionForValue(newValue);
	      var newInputState = {
	        value: newValue,
	        selection: newSelection
	      };

	      if (beforeMaskedStateChange) {
	        newInputState = beforeMaskedStateChange({
	          currentState: getInputState(),
	          nextState: newInputState
	        });
	        newValue = newInputState.value;
	        newSelection = newInputState.selection;
	      }

	      setInputState(newInputState);

	      if (newValue !== currentValue && props.onChange) {
	        props.onChange(event);
	      } // Chrome resets selection after focus event,
	      // so we want to restore it later


	      defer(function () {
	        setInputState(getLastInputState());
	      });
	    }

	    if (props.onFocus) {
	      props.onFocus(event);
	    }
	  }

	  function onBlur(event) {
	    var currentValue = getInputState().value;
	    var lastValue = getLastInputState().value;

	    if (isMasked && !alwaysShowMask && maskUtils.isValueEmpty(lastValue)) {
	      var newValue = "";
	      var newInputState = {
	        value: newValue,
	        selection: {
	          start: null,
	          end: null
	        }
	      };

	      if (beforeMaskedStateChange) {
	        newInputState = beforeMaskedStateChange({
	          currentState: getInputState(),
	          nextState: newInputState
	        });
	        newValue = newInputState.value;
	      }

	      setInputState(newInputState);

	      if (newValue !== currentValue && props.onChange) {
	        props.onChange(event);
	      }
	    }

	    if (props.onBlur) {
	      props.onBlur(event);
	    }
	  } // Tiny unintentional mouse movements can break cursor
	  // position on focus, so we have to restore it in that case
	  //
	  // https://github.com/sanniassin/react-input-mask/issues/108


	  function onMouseDown(event) {
	    var input = getInputElement();

	    var _getInputState = getInputState(),
	        value = _getInputState.value;

	    var inputDocument = getElementDocument(input);

	    if (!isInputFocused(input) && !maskUtils.isValueFilled(value)) {
	      var mouseDownX = event.clientX;
	      var mouseDownY = event.clientY;
	      var mouseDownTime = new Date().getTime();

	      var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
	        inputDocument.removeEventListener("mouseup", mouseUpHandler);

	        if (!isInputFocused(input)) {
	          return;
	        }

	        var deltaX = Math.abs(mouseUpEvent.clientX - mouseDownX);
	        var deltaY = Math.abs(mouseUpEvent.clientY - mouseDownY);
	        var axisDelta = Math.max(deltaX, deltaY);
	        var timeDelta = new Date().getTime() - mouseDownTime;

	        if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
	          var _lastState = getLastInputState();

	          var newSelection = maskUtils.getDefaultSelectionForValue(_lastState.value);

	          var newState = _extends({}, _lastState, {
	            selection: newSelection
	          });

	          setInputState(newState);
	        }
	      };

	      inputDocument.addEventListener("mouseup", mouseUpHandler);
	    }

	    if (props.onMouseDown) {
	      props.onMouseDown(event);
	    }
	  } // For controlled inputs we want to provide properly formatted
	  // value prop


	  if (isMasked && isControlled) {
	    var input = getInputElement();
	    var isFocused = input && isInputFocused(input);
	    var newValue = isFocused || alwaysShowMask || props.value ? maskUtils.formatValue(props.value) : props.value;

	    if (beforeMaskedStateChange) {
	      newValue = beforeMaskedStateChange({
	        nextState: {
	          value: newValue,
	          selection: {
	            start: null,
	            end: null
	          }
	        }
	      }).value;
	    }

	    setInputState(_extends({}, getLastInputState(), {
	      value: newValue
	    }));
	  }

	  var lastState = getLastInputState();
	  var lastSelection = lastState.selection;
	  var lastValue = lastState.value;
	  React.useLayoutEffect(function () {
	    if (!isMasked) {
	      return;
	    }

	    var input = getInputElement();
	    var isFocused = isInputFocused(input);
	    var previousSelection = lastSelection;
	    var currentState = getInputState();

	    var newInputState = _extends({}, currentState); // Update value for uncontrolled inputs to make sure
	    // it's always in sync with mask props


	    if (!isControlled) {
	      var currentValue = currentState.value;
	      var formattedValue = maskUtils.formatValue(currentValue);
	      var isValueEmpty = maskUtils.isValueEmpty(formattedValue);
	      var shouldFormatValue = !isValueEmpty || isFocused || alwaysShowMask;

	      if (shouldFormatValue) {
	        newInputState.value = formattedValue;
	      } else if (isValueEmpty && !isFocused) {
	        newInputState.value = "";
	      }
	    }

	    if (isFocused && !previousIsMasked) {
	      // Adjust selection if input got masked while being focused
	      newInputState.selection = maskUtils.getDefaultSelectionForValue(newInputState.value);
	    } else if (isControlled && isFocused && previousSelection) {
	      // Restore cursor position if value has changed outside change event
	      if (previousSelection.start !== null && previousSelection.end !== null) {
	        newInputState.selection = previousSelection;
	      }
	    }

	    if (beforeMaskedStateChange) {
	      newInputState = beforeMaskedStateChange({
	        currentState: currentState,
	        nextState: newInputState
	      });
	    }

	    setInputState(newInputState);
	  });

	  var inputProps = _extends({}, restProps, {
	    onFocus: onFocus,
	    onBlur: onBlur,
	    onChange: isMasked && isEditable ? onChange : props.onChange,
	    onMouseDown: isMasked && isEditable ? onMouseDown : props.onMouseDown,
	    ref: function ref(_ref) {
	      inputRef.current = reactDom.findDOMNode(_ref);

	      if (isFunction(forwardedRef)) {
	        forwardedRef(_ref);
	      } else if (forwardedRef !== null && typeof forwardedRef === "object") {
	        forwardedRef.current = _ref;
	      }
	    },
	    value: isMasked && isControlled ? lastValue : props.value
	  });

	  if (children) {
	    validateChildren(props, children); // We wrap children into a class component to be able to find
	    // their input element using findDOMNode

	    return React__default$1.createElement(InputMaskChildrenWrapper, inputProps, children);
	  }

	  return React__default$1.createElement("input", inputProps);
	});
	InputMask.displayName = "InputMask";
	InputMask.defaultProps = {
	  alwaysShowMask: false,
	  maskPlaceholder: "_"
	};
	InputMask.propTypes = {
	  alwaysShowMask: PropTypes.bool,
	  beforeMaskedStateChange: PropTypes.func,
	  children: PropTypes.element,
	  mask: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]))]),
	  maskPlaceholder: PropTypes.string,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func,
	  onMouseDown: PropTypes.func
	};

	reactInputMask_development = InputMask;
	return reactInputMask_development;
}

/* eslint-disable import/no-unresolved */

if (process.env.NODE_ENV === "production") {
  reactInputMask.exports = requireReactInputMask_production_min();
} else {
  reactInputMask.exports = requireReactInputMask_development();
}

var reactInputMaskExports = reactInputMask.exports;
var InputMask = /*@__PURE__*/getDefaultExportFromCjs(reactInputMaskExports);

const styled$1 = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Label = ({
  children,
  small,
  withLeftIcon,
  withLeftContent,
  inlineLabel = false
}) => {
  return /*#__PURE__*/React__default.createElement(Container, {
    small: small,
    withLeftIcon: withLeftIcon,
    withLeftContent: withLeftContent,
    inlineLabel: inlineLabel
  }, children);
};
const Container = styled$1.label`
  pointer-events: none;
  position: absolute;
  top: 0;
  transform: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  transform: translate(0, 16px) scale(1);
  transition: all 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  ${({
  theme
}) => css(["color:", ";font-family:", ";font-size:", ";font-weight:", ";left:", "px;line-height:", "px;"], theme.colors.quinary, theme.typographies['label-1'].fontFamily, theme.typographies['label-1'].fontSize, theme.typographies['label-1'].fontWeight, theme.spacings.small, theme.typographies['label-1'].lineHeight)}

  ${({
  theme,
  inlineLabel,
  small
}) => small && !inlineLabel && css(["color:", ";font-family:", ";font-weight:", ";line-height:", "px;top:10px;transform-origin:top left;transform:scale(0.75);"], theme.colors.tertiary, theme.typographies['caption-1'].fontFamily, theme.typographies['caption-1'].fontWeight, theme.typographies['caption-1'].lineHeight)}

  ${({
  theme,
  withLeftIcon
}) => withLeftIcon && css(["left:", "px;"], theme.spacings.xxxLarge - theme.borderWidths.large)}

  ${({
  theme,
  withLeftContent
}) => withLeftContent && css(["left:", "px;"], theme.spacings.xxxxLarge - theme.borderWidths.large)}
`;

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const InputField = /*#__PURE__*/forwardRef(({
  alt,
  autoComplete,
  autoFocus,
  defaultValue,
  disabled = false,
  disableSearch = false,
  centerInputText = false,
  error = false,
  hintColor = 'info',
  hintText,
  iconLeftProps,
  iconRightProps,
  id,
  leftContent,
  mask = '',
  maskPlaceholder = null,
  maxLength,
  minLength,
  name,
  onChange,
  onKeyDown,
  onChangeText,
  onFocus = noop,
  onBlur = noop,
  placeholder,
  readOnly,
  required,
  step,
  testID,
  type,
  value = '',
  hideLabel = false,
  inlineLabel = false,
  borderWidth = 'large'
}, ref) => {
  const [isFocused, setFocused] = useState(false);
  const localRef = useRef(null);
  const handleChange = event => {
    if (onChange) {
      onChange(event);
    }
    if (onChangeText) {
      onChangeText(event.currentTarget.value);
    }
  };
  const handleFocus = event => {
    if (!readOnly) setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };
  const handleBlur = event => {
    setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputContainer, null, iconLeftProps && /*#__PURE__*/React__default.createElement(Box, {
    position: "absolute",
    top: "16px",
    left: "16px"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    color: iconLeftProps.color,
    name: iconLeftProps.name,
    onPress: iconLeftProps.onPress,
    testID: iconLeftProps.testID
  })), leftContent && /*#__PURE__*/React__default.createElement(Box, {
    position: "absolute",
    top: "16px",
    left: "16px"
  }, leftContent()), /*#__PURE__*/React__default.createElement(InputMask, {
    alwaysShowMask: false,
    disabled: disabled,
    mask: mask,
    maskPlaceholder: maskPlaceholder,
    onBlur: handleBlur,
    onKeyDown: onKeyDown,
    onChange: disabled ? noop : handleChange,
    onFocus: handleFocus,
    readOnly: readOnly,
    value: value
  }, /*#__PURE__*/React__default.createElement(Input, {
    alt: alt,
    centerInputText: centerInputText,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    "data-testid": testID,
    disableSearch: disableSearch,
    defaultValue: defaultValue,
    error: error,
    id: id,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    ref: mergeRefs([localRef, ref]),
    required: required,
    step: step,
    type: type,
    withLeftIcon: Boolean(iconLeftProps),
    withRightIcon: Boolean(iconRightProps),
    withLeftContent: Boolean(leftContent),
    hideLabel: hideLabel,
    inlineLabel: inlineLabel,
    borderWidth: borderWidth
  })), (!hideLabel && !inlineLabel || inlineLabel && !value) && /*#__PURE__*/React__default.createElement(Label, {
    small: Boolean(isFocused || value),
    inlineLabel: inlineLabel,
    withLeftIcon: Boolean(iconLeftProps),
    withLeftContent: Boolean(leftContent)
  }, placeholder), iconRightProps && /*#__PURE__*/React__default.createElement(Box, {
    position: "absolute",
    top: "16px",
    right: "16px"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    color: iconRightProps.color,
    name: iconRightProps.name,
    onPress: iconRightProps.onPress,
    testID: iconRightProps.testID
  }))), hintText && /*#__PURE__*/React__default.createElement(Box, {
    marginTop: "xTiny"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: error ? 'error' : hintColor,
    variant: "caption-1"
  }, hintText)));
});
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;
const Input = styled.input`
  ${({
  theme,
  borderWidth,
  disableSearch
}) => css(["background:", ";border-color:", ";border-radius:", "px;border-style:solid;border-width:", "px;box-sizing:border-box;color:", ";font-family:", ";font-size:", "px;font-weight:", ";line-height:", "px;outline:none;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;padding-top:", "px;width:100%;::-webkit-credentials-auto-fill-button{visibility:hidden;pointer-events:none;position:absolute;right:0;}&:disabled,&:read-only{background:", ";color:", ";cursor:", ";+ label{color:", ";}}&:focus:enabled{border-color:", ";}&:read-only:focus:enabled{border-color:", ";}"], theme.shapeFills.senary, theme.borderColors.primary, theme.borderRadius.base, theme.borderWidths[borderWidth], theme.colors.primary, theme.typographies['label-1'].fontFamily, theme.typographies['label-1'].fontSize, theme.typographies['label-1'].fontWeight, theme.typographies['label-1'].lineHeight, theme.spacings.tiny - theme.borderWidths.large, theme.spacings.small - theme.borderWidths.large, theme.spacings.small - theme.borderWidths.large, theme.spacings.base - theme.borderWidths.large, disableSearch ? undefined : theme.shapeFills.quinary, disableSearch ? undefined : theme.colors.quaternary, disableSearch ? 'pointer' : 'not-allowed', disableSearch ? undefined : theme.colors.quaternary, theme.borderColors.tertiary, theme.borderColors.primary)}

  ${({
  theme,
  withLeftIcon
}) => withLeftIcon && css(["padding-left:", "px;"], theme.spacings.xxxLarge - theme.borderWidths.large)}

  ${({
  theme,
  withLeftContent
}) => withLeftContent && css(["padding-left:", "px;"], theme.spacings.xxxxLarge - theme.borderWidths.large)}

  ${({
  theme,
  withRightIcon
}) => withRightIcon && css(["padding-right:", "px;"], theme.spacings.xxxLarge - theme.borderWidths.large)}

  ${({
  theme,
  hideLabel,
  inlineLabel
}) => (hideLabel || inlineLabel) && css(["padding-top:", "px;padding-bottom:", "px;"], theme.spacings.small - theme.borderWidths.large, theme.spacings.small - theme.borderWidths.large)}


  ${({
  theme,
  error
}) => error && css(["border-color:", ";"], theme.borderColors.error)}

    ${({
  theme,
  error
}) => error && css(["border-color:", ";"], theme.borderColors.error)}
   
  ${({
  theme,
  centerInputText
}) => centerInputText && css(["padding:", "px;text-align:center;"], theme.spacings.large - theme.spacings.small)}
`;

export { InputField as I, mergeRefs as m };
//# sourceMappingURL=index-a717eeb1.js.map
